<img
  alt="octo-error.png"
  class="mx-auto"
  src="assets/core/octo-error.png"
/>

<div class="portal-subheading">Something went wrong</div>
